/**
 * Global application constants
 */

/**
 * Default number of items to fetch per page in list views.
 * Used for cursor-based pagination with GraphQL's `first` argument.
 */
export const DEFAULT_PAGE_SIZE = 50;
